export default "__VITE_ASSET__CoaV$S7B__"